import { notFound } from 'next/navigation';

import type { IAccommodationRoomStatus } from '@/entities/accommodation/types';
import { NEXT_PUBLIC_API_URL } from '@/lib/env';
import { utilFetch } from '@/lib/utils';

const apiGetAccommodationRoomStatusList = async ({
  idx,
}: {
  idx: string;
}): Promise<IAccommodationRoomStatus[]> => {
  const response = await utilFetch()(
    `${NEXT_PUBLIC_API_URL}/api/accommodations/rooms/${idx}/status`,
    {
      method: 'GET',
    },
  );
  const result = await response.json();

  // error handling
  if (!result.ok) {
    notFound();
  }

  return filterRoomStatusList(result.data);
};

export default apiGetAccommodationRoomStatusList;

const filterRoomStatusList = (
  roomStatusList: IAccommodationRoomStatus[],
): IAccommodationRoomStatus[] => {
  return roomStatusList.sort(
    (a: IAccommodationRoomStatus, b: IAccommodationRoomStatus) =>
      new Date(a.date).getTime() - new Date(b.date).getTime(),
  );
};
